import React from 'react';
import './zendesk-cta.scss';
import i18n from '../locales/i18n';

const ZendeskCTA = (props) => {
  return (
    <a className="zendesk-cta help-icon" href={i18n.t('partner_journey.help_center_article')} target="_blank">
      {i18n.t('help')}
    </a>
  );
};

export default ZendeskCTA;
